module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "push"
  }, [(!_vm.hideSearchBar) ? _c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('input', {
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ("Zoek " + _vm.itemLabelSingular + "...")
    },
    on: {
      "input": _vm.search
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [(_vm.filter) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-light"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('strong', [_vm._v(_vm._s(this.currentStart) + "-" + _vm._s(this.currentEnd))]), _vm._v(" van "), _c('strong', [_vm._v(_vm._s(this.totalRows))]), _vm._v(" " + _vm._s(_vm.itemLabelPlural) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_vm._t("before-block-options"), _vm._v(" "), (_vm.sortBy) ? _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sortBy = null
      }
    }
  }, [_c('i', {
    staticClass: "si si-close"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "si si-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "si si-arrow-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "si si-refresh"
  })]), _vm._v(" "), _vm._t("after-block-options")], 2)]), _vm._v(" "), _vm._t("before-block-content"), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "padding": "8px 0 0 0"
    }
  }, [_c('b-table', {
    ref: "table",
    staticClass: "table-vcenter table-responsive",
    attrs: {
      "hover": "",
      "show-empty": "",
      "fields": _vm.fields,
      "items": _vm.getItems,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "empty-text": ("Er zijn geen " + _vm.itemLabelPlural),
      "empty-filtered-text": ("Geen " + _vm.itemLabelPlural + " gevonden")
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(field, key) {
      return {
        key: key,
        fn: function(data) {
          return [_c('div', {
            key: key
          }, [_vm._t(key, [_vm._v(_vm._s(data.value))], null, data)], 2)]
        }
      }
    })])
  })], 1), _vm._v(" "), _vm._t("after-block-content")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e42802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/ApiTableBlock.vue
// module id = 737
// module chunks = 1